import {
    createHandlerChainRunnerOptionalParameter,
    Handler,
    makeHandlerChainAwaitable,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import validateAddress, { AddressErrors } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import { BillToModel, CountryModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import {
    ValidateBillingAddress,
    chain,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetInitialValues";

type HandlerType = Handler<
    {},
    {
        cart: Cart;
        billTo: BillToModel;
        shipTo: ShipToModel;
        country: CountryModel | undefined;
        shipTos: ShipToModel[];
    }
>;

export const ValidateBillingAddressExtension: HandlerType = async ({ dispatch, getState, billTo }) => {
    const state = getState();
    const billingAddressFormState = state.pages.onePageCheckout.billingAddressFormState;
    if (!billingAddressFormState) {
        return;
    }

    let addressFieldsDataView: any = getAddressFieldsDataView(state);

    if (!addressFieldsDataView.value) {
        addressFieldsDataView = getAddressFieldsDataView(state);
    }

    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
        validateAddress,
    );
    const billingAddressErrors = await awaitableValidate({
        address: billTo,
        validationRules: billTo.validation!,
        addressFieldDisplayCollection: addressFieldsDataView?.value?.billToAddressFields || {},
    })(dispatch, getState);
    const isBillingAddressValid = Object.keys(billingAddressErrors).length === 0;

    dispatch({
        type: "Pages/OnePageCheckout/SetIsBillingAddressUpdateRequired",
        isBillingAddressUpdateRequired: !isBillingAddressValid,
    });
};

replaceInChain(chain, ValidateBillingAddress, ValidateBillingAddressExtension);
